import axios from "../../lib/axiosInstance";

export function createOffer(payload) {
  return axios.post("offers/engineer/request", payload).then((res) => res.data);
}

export function createCounterOffer(payload) {
  return axios.patch("offers/engineer/counter", payload).then((res) => res.data);
}

// A client sends a counter offer to the customer who raised a PENDING_APPROVAL work
// order. While one awaits the customer it is edited or withdrawn, not re-sent.
export function sendCustomerCounterOffer(payload) {
  return axios.post("offers/customer/counter", payload).then((res) => res.data);
}

// Replaces the pending counter offer's proposal (rates and expenses) in place.
export function updateCustomerCounterOffer(offerId, payload) {
  return axios.patch(`offers/customer/counter/${offerId}`, payload).then((res) => res.data);
}

export function withdrawCustomerCounterOffer(offerId) {
  return axios.post(`offers/customer/counter/withdraw/${offerId}`).then((res) => res.data);
}

export function fetchCustomerCounterOffer(workOrderId) {
  return axios.get(`offers/customer/counter/${workOrderId}`).then((res) => res.data);
}

// `updatedAt` is the proposal version the customer is looking at. If the provider
// has edited it since, the server refuses with a 409 (code COUNTER_OFFER_CHANGED).
export function acceptCustomerCounterOffer({ offerId, updatedAt }) {
  return axios
    .post(`offers/customer/counter/accept/${offerId}`, { updatedAt })
    .then((res) => res.data);
}

export function declineCustomerCounterOffer({ offerId, updatedAt }) {
  return axios
    .post(`offers/customer/counter/decline/${offerId}`, { updatedAt })
    .then((res) => res.data);
}

export function declineOffer(payload) {
  return axios.post("offers/engineer/notInterested", payload).then((res) => res.data);
}

export function fetchWorkOrderOffers(payload) {
  return axios.post(`offers/${payload.id}`, payload).then((res) => res.data);
}

export function assignWorkOrderToFreelancer(payload) {
  return axios.post(`offers/assign`, payload).then((res) => res.data);
}

export function updateWorkOrderStatus(payload) {
  return axios.post(`offers/status`, payload).then((res) => res.data);
}

export function routeOffer(payload) {
  return axios.post("offers/route", payload).then((res) => res.data);
}

export function deleteOffer(id) {
  return axios.delete(`offers/${id}`).then((res) => res.data);
}

export function unrouteOffers(payload) {
  return axios.post("offers/unroute", payload).then((res) => res.data);
}

export function withdrawOffer(id) {
  return axios.delete(`offers/engineer/withdraw/${id}`).then((res) => res.data);
}

export function fetchUserCounterOffer(payload) {
  return axios.post(`offers/engineer/workOrder/${payload?.id}`, payload).then((res) => res.data);
}

export function deleteOfferExpense(id) {
  return axios.delete(`offers/engineer/expense/${id}`).then((res) => res.data);
}

export function acceptCounterOffer(offerId) {
  return axios.post(`offers/counter/accept/${offerId}`).then((res) => res.data);
}

export function acceptRoutedOffer({ offerId, referredEngineerId }) {
  return axios
    .post(`offers/route/accept/${offerId}`, { referredEngineerId })
    .then((res) => res.data);
}
